import { reviews } from '@/mocks/categories';

const reviewPhoto1 = "https://readdy.ai/api/search-image?query=Genuine%20unboxing%20moment%20hands%20opening%20package%20with%20fashion%20items%20visible%20warm%20natural%20window%20lighting%20lifestyle%20editorial%20photography%20authentic%20joyful%20expression%20clean%20modern%20interior%20neutral%20warm%20tones%20candid%20feel%20soft%20shadows&width=900&height=500&seq=review-photo-v3&orientation=landscape";

export default function Reviews() {
  return (
    <section className="relative bg-background-100 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="w-8 h-8 mx-auto mb-4 flex items-center justify-center">
            <i className="ri-double-quotes-l text-2xl text-secondary-500"></i>
          </div>
          <p className="text-foreground-400 text-xs md:text-sm font-semibold uppercase tracking-[0.2em] mb-3">
            Reviews
          </p>
          <h2 className="font-heading text-foreground-900 text-3xl md:text-4xl lg:text-5xl font-bold">
            Avaliações de Compradores
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {reviews.slice(0, 3).map((review) => (
            <div key={review.name} className="bg-background-50 rounded-2xl p-6 md:p-7">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-foreground-900 font-semibold text-sm md:text-base">{review.name}</p>
                  <p className="text-foreground-400 text-xs">{review.role}</p>
                </div>
              </div>
              <div className="mb-3">
                <i className="ri-double-quotes-l text-secondary-500/40 text-xl"></i>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {review.text}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          <div className="md:col-span-2 relative min-h-[200px] rounded-2xl overflow-hidden">
            <img
              src={reviewPhoto1}
              alt="CSSBuy unboxing experience"
              className="absolute inset-0 w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-foreground-900/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <p className="text-white font-semibold text-sm md:text-base">{reviews[3].name}</p>
              <p className="text-white/70 text-xs mb-2">{reviews[3].role}</p>
              <p className="text-white/90 text-sm leading-relaxed max-w-lg">{reviews[3].text}</p>
            </div>
          </div>

          <div className="flex flex-col gap-5 md:gap-6">
            <div className="flex-1 bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col justify-between">
              <div>
                <i className="ri-double-quotes-l text-secondary-500/40 text-xl mb-2 block"></i>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">{reviews[4].text}</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={reviews[4].avatar}
                    alt={reviews[4].name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-foreground-900 font-semibold text-xs md:text-sm">{reviews[4].name}</p>
                  <p className="text-foreground-400 text-[10px] md:text-xs">{reviews[4].role}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}